import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl } from '../../global/mediaQueryMixin';

const DropBox = styled.div`
  .menuStyle {
    display: flex;
    flex-direction: column;
    padding: 3px 0;
    background: var(--background-primary);
    border: 0.5px solid var(--border-primary);
    box-shadow: var(--shadow-modal);
    border-radius: 8px;
    margin: 0px;
    width: 100px;

    .menuitem {
      margin: 0;
      :hover {
        background-color: var(--neutral-secondary);
        border-radius: 0;
      }
    }
  }
`;

const DropText = styled.div`
  ${Typography.body_md_medium}
  color: var(--text-primary);
  margin: 0;
  padding: 6px 12px;
  cursor: pointer;
`;

const ScreenRecordMain = styled.div<{ isStartFromVideo?: boolean }>`
  margin-top: 12px;
  :first-child {
    margin-top: 10px !important;
  }
  ${mobile_xl(css`
    width: 100%;
    margin-top: 8px;
  }
      `)}
  .e-rte-video .e-video-inline {
    width: 355px !important;
  }

  .react-player__play-icon {
    display: none;
  }
`;

const YoutubePlayer = styled.div`
  height: 200px;
  width: 353px;
  .img-thumbnail {
    border: 0.5px solid var(--border-primary);
    max-width: unset;
  }
  ${mobile_xl(css`
    width: 100%;
    height: auto;
    .img-thumbnail {
      width: 100% !important;
      height: auto !important;
      border: unset;
      border-radius: 0;
    }
  `)}
`;

export { DropBox, DropText, ScreenRecordMain, YoutubePlayer };
